<template functional>
  <svg
    role="presentation"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="props.size"
    :height="props.size"
    viewBox="0 0 16 16"
  >
    <g transform="translate(1 3)">
      <path d="M6.5,9c2.761,0,5-1.007,5-2.25S9.261,4.5,6.5,4.5s-5,1.007-5,2.25S3.739,9,6.5,9Z" transform="translate(-1.5 -4.5)" fill="none" stroke="#74788d" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" :style="{ fill: 'none !important' }" />
      <path d="M1.5,7.875v2.5c0,1.244,2.237,2.25,5,2.25s5-1.007,5-2.25v-2.5" transform="translate(-1.5 -5.625)" fill="none" stroke="#74788d" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" :style="{ fill: 'none !important' }" />
      <path d="M6,10.969v2.5" transform="translate(-3 -6.656)" fill="none" stroke="#74788d" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" :style="{ fill: 'none !important' }" />
      <path d="M14.391,9.066c2.281.213,4,1.119,4,2.207,0,1.243-2.237,2.25-5,2.25A9.393,9.393,0,0,1,10.172,13" transform="translate(-4.391 -6.022)" fill="none" stroke="#74788d" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" :style="{ fill: 'none !important' }" />
      <path d="M7.5,14.081v.794c0,1.244,2.237,2.25,5,2.25s5-1.007,5-2.25v-2.5" transform="translate(-3.5 -7.125)" fill="none" stroke="#74788d" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" :style="{ fill: 'none !important' }"/>
      <path d="M18,15.469v2.5" transform="translate(-7 -8.156)" fill="none" stroke="#74788d" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" :style="{ fill: 'none !important' }" />
      <path d="M12,10.969v5.5" transform="translate(-5 -6.656)" fill="none" stroke="#74788d" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" :style="{ fill: 'none !important' }" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconCoins',

  props: {
    size: { type: [String, Number], default: '16px' },
  }
}
</script>